/**
 * Permissions Matrix Dialog
 *
 * A minimal dialog wrapper that displays the read-only RolePermissionsTable.
 * The close button is part of the card itself.
 */

import { Dialog } from '@mui/material';

import { RolePermissionsTable } from './RolePermissionsTable';

interface PermissionsMatrixDialogProps {
  open: boolean;
  onClose: () => void;
}

export function PermissionsMatrixDialog({ open, onClose }: PermissionsMatrixDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
     maxWidth={"md"} slotProps={{ paper: {
        sx: {
          // Remove default Dialog padding since the Card has its own styling
          overflow: 'hidden',
        },
      } }}>
      <RolePermissionsTable onClose={onClose} title="Role Permissions" />
    </Dialog>
  );
}
